// extracted by mini-css-extract-plugin
export default {"image-container":"styles_image-container__ua9-E","text-container":"styles_text-container__p1I+E","container":"styles_container__0uRwZ"};